import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orderLookup: {
    isLoading: false,
    error: false,
    errorMessage: '',
    data: null,
  },
};

const slice = createSlice({
  name: 'appStoreLookup',
  initialState,
  reducers: {
    startLoading(state) {
      state.orderLookup.isLoading = true;
    },
    hasError(state, action) {
      state.orderLookup.isLoading = false;
      state.orderLookup.error = action.payload;
      state.orderLookup.errorMessage = action.payload;
      state.orderLookup.data = null;
    },
    lookupOrderSuccess(state, action) {
      state.orderLookup.isLoading = false;
      state.orderLookup.error = false;
      state.orderLookup.data = action.payload;
    },
    clearLookupData(state) {
      state.orderLookup.data = null;
      state.orderLookup.error = false;
    },
  },
});

export default slice.reducer;

export function lookupAppStoreOrder(appId, orderId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/admin/${appId}/app-store-lookup/${orderId}`);

      // Check if the response has actual data
      if (response.success && (!response.data || Object.keys(response.data).length === 0)) {
        dispatch(slice.actions.hasError('No transaction found with this order ID'));
        return { success: false, error: 'No transaction found with this order ID' };
      }

      dispatch(slice.actions.lookupOrderSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      const errorMessage = error.message || 'Failed to lookup order';
      dispatch(slice.actions.hasError(errorMessage));
      return { success: false, error: errorMessage };
    }
  };
}

export function clearLookupData() {
  return (dispatch) => {
    dispatch(slice.actions.clearLookupData());
  };
}
